import getDueIn from '@/utils/getDueIn';
import { cn } from '@/utils/helper';

interface IDuration {
  expirationDate: string | number;
  children?: React.ReactNode;
  isUnpaid?: boolean;
  status?: string;
}
export const rowBaseClassName = (isUnpaid?: boolean) => cn('text-[10px]/3 lg:text-sm font-normal font-space-mono', isUnpaid ? 'group-hover:!text-primary' : 'group-hover:!text-primary');

const Duration: React.FC<IDuration> = ({ children, expirationDate, isUnpaid, status }) => {
  const dueIn = getDueIn(expirationDate);

  return (
    <div className='flex gap-1 items-center w-max mx-auto'>
      {status ? <p className={rowBaseClassName(isUnpaid)}>{status === 'active' ? dueIn : '---'}</p> : <p className={rowBaseClassName(isUnpaid)}>{dueIn}</p>}
      {children}
    </div>
  );
};
export default Duration;
